/**
 * SubtypePill — the BANK→BANK / BANK→CASH / CASH→BANK / BANK→CARD chip.
 *
 * Mirrors `prototype/cash/transfers.html ▸ .subtype-pill` exactly — same
 * mono font, 4-tone colour mapping:
 *
 *   bank→bank  slate     (the default — same-class intra-bank wire)
 *   bank→cash  emerald   (petty-cash top-up — money leaves the system into the drawer)
 *   cash→bank  emerald   (banking surplus — dashed border distinguishes direction)
 *   bank→card  amber     (statement payoff — flagged for partial-payment guard)
 *
 * @see prototype/cash/transfers.html `.subtype-pill`
 */
import { cn } from "@flint/ui";
import { SUBTYPE_LABEL, type TransferSubtype } from "../lib/classify-subtype.ts";

const SUBTYPE_TONE: Record<TransferSubtype, string> = {
  bank_to_bank: "bg-raised text-ink-2 border-line",
  bank_to_cash: "bg-ok-50 text-ok border-ok-100",
  cash_to_bank: "bg-paper text-ok border-ok-100 border-dashed",
  bank_to_card: "bg-warn-50 text-warn border-warn-100",
};

export interface SubtypePillProps {
  subtype: TransferSubtype;
}

export function SubtypePill({ subtype }: SubtypePillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-sm font-mono font-semibold text-xs tracking-wider uppercase whitespace-nowrap border",
        SUBTYPE_TONE[subtype],
      )}
    >
      {SUBTYPE_LABEL[subtype]}
    </span>
  );
}
